import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
/**
 * A Component implementing a bootstrap card with internal tabs in the header
 */

var TabCard = function TabCard(_ref) {
  var selectedIndex = _ref.selectedIndex,
      onSelect = _ref.onSelect,
      tabs = _ref.tabs;
  var initialSelectedIndex = selectedIndex > 0 ? selectedIndex : 0;

  var _useState = useState(initialSelectedIndex),
      _useState2 = _slicedToArray(_useState, 2),
      localSelectedIndex = _useState2[0],
      setLocalSelectedIndex = _useState2[1];

  var onTabSelect = function onTabSelect(e, selectedKey) {
    e.preventDefault();
    setLocalSelectedIndex(selectedKey);

    if (onSelect) {
      onSelect(e, selectedKey);
    }
  };

  var getTabClass = function getTabClass(index) {
    return index === localSelectedIndex ? 'nav-item active' : 'nav-item';
  };

  useEffect(function () {
    if (selectedIndex >= 0) {
      setLocalSelectedIndex(selectedIndex);
    }
  }, [setLocalSelectedIndex, selectedIndex]);

  var renderTab = function renderTab(tabInfo, tabIndex) {
    return React.createElement("li", {
      key: tabIndex,
      className: getTabClass(tabIndex)
    }, React.createElement("a", {
      href: tabInfo.href || null,
      className: "nav-link",
      onClick: function onClick(e) {
        return onTabSelect(e, tabIndex);
      }
    }, React.createElement("strong", null, " ", tabInfo.name, " ")));
  };

  var renderTabNav = function renderTabNav() {
    return React.createElement("ul", {
      className: "nav card-tab-nav"
    }, " ", tabs.map(renderTab), " ");
  };

  var renderFooter = function renderFooter() {
    if (tabs[localSelectedIndex].footer) {
      return React.createElement("div", {
        className: "card-footer"
      }, " ", tabs[localSelectedIndex].footer, " ");
    }

    return null;
  };

  return React.createElement("div", {
    className: "card tab-card"
  }, React.createElement("div", {
    className: "card-header card-tabs"
  }, renderTabNav()), React.createElement("div", {
    className: "card-block"
  }, tabs[localSelectedIndex].block), renderFooter());
};

TabCard.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.node.isRequired,
    block: PropTypes.node.isRequired,
    footer: PropTypes.node,
    href: PropTypes.string
  })),
  onSelect: PropTypes.func,
  selectedIndex: PropTypes.number
};
TabCard.defaultProps = {
  tabs: [],
  onSelect: function onSelect() {},
  selectedIndex: undefined
};
export default TabCard;